import * as React from 'react';

var _rect, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgGitHub = function SvgGitHub(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        width: 120,
        height: 120,
        fill: "#000",
        rx: 60
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M78.557 117.072A59.9 59.9 0 0 1 60 120c-6.48 0-12.72-1.029-18.568-2.932 2.701.324 3.7-1.435 3.7-2.953 0-.661-.012-1.827-.027-3.387-.017-1.805-.04-4.137-.056-6.824-16.691 3.628-20.212-8.05-20.212-8.05-2.727-6.934-6.66-8.78-6.66-8.78-5.45-3.727.412-3.651.412-3.651 6.019.424 9.188 6.188 9.188 6.188 5.355 9.175 14.043 6.526 17.463 4.987.544-3.88 2.097-6.526 3.81-8.027-13.323-1.516-27.33-6.665-27.33-29.672 0-6.556 2.337-11.914 6.177-16.113-.62-1.52-2.678-7.622.585-15.889 0 0 5.04-1.614 16.5 6.155 4.788-1.333 9.918-1.997 15.022-2.024 5.096.027 10.23.691 15.023 2.024 11.452-7.769 16.48-6.155 16.48-6.155 3.275 8.267 1.216 14.37.597 15.889 3.848 4.2 6.169 9.557 6.169 16.113 0 23.063-14.029 28.141-27.394 29.627 2.153 1.854 4.073 5.516 4.073 11.119 0 5.367-.034 10.04-.056 13.136-.011 1.534-.02 2.682-.02 3.335 0 1.525.975 3.287 3.68 2.956",
        clipRule: "evenodd"
    })));
};

export { SvgGitHub as ReactComponent };
//# sourceMappingURL=GitHub.svg.es.js.map
